
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { LoadingSpinner } from "@/components/LoadingSpinner";

interface SubscriptionTierProps {
  name: string;
  price: number;
  description: string;
  features: string[];
  priceId: string;
  isLoading: boolean;
  selectedTier: string | null;
  onSubscribe: (priceId: string) => void;
}

export function SubscriptionTierCard({
  name,
  price,
  description,
  features,
  priceId,
  isLoading,
  selectedTier,
  onSubscribe,
}: SubscriptionTierProps) {
  return (
    <Card className="p-6 flex flex-col">
      <div className="mb-6">
        <h3 className="text-2xl font-bold text-primary">{name}</h3>
        <p className="text-muted-foreground">{description}</p>
      </div>
      <div className="mb-6">
        {name === "Free" ? (
          <>
            <span className="text-4xl font-bold">$0</span>
            <span className="text-muted-foreground">/month</span>
          </>
        ) : (
          <>
            <span className="text-4xl font-bold">${price}</span>
            <span className="text-muted-foreground">/month</span>
          </>
        )}
      </div>
      <ul className="space-y-3 mb-8 flex-grow">
        {features.map((feature, featureIndex) => (
          <li key={featureIndex} className="flex items-center gap-2">
            <Check className="h-5 w-5 text-primary" />
            <span>{feature}</span>
          </li>
        ))}
        {name === "Free" && (
          <li className="flex items-center gap-2">
            <Check className="h-5 w-5 text-primary" />
            <span>Valid for 3 days</span>
          </li>
        )}
      </ul>
      <Button
        className="w-full"
        onClick={() => onSubscribe(priceId)}
        disabled={isLoading && selectedTier === priceId}
      >
        {isLoading && selectedTier === priceId ? (
          <LoadingSpinner />
        ) : (
          'Subscribe'
        )}
      </Button>
    </Card>
  );
}
